// removed by extract-text-webpack-plugin
module.exports = {"form":"f2004","images":"_5e6d0","empty":"_23052"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Home/home.css
// module id = 140
// module chunks = 0